module.exports = __webpack_public_path__ + "static/media/bootstrap-original.f767e609.svg";